import PageHeader from "@/components/layout/PageHeader";
import EstimateForm from "@/components/forms/EstimateForm";
import { BUSINESS, SERVICE_AREAS } from "@/lib/site";
import { Phone, Mail, Clock, MapPin, Instagram } from "lucide-react";

export default function ContactPage() {
  return (
    <div data-testid="contact-page">
      <PageHeader
        overline="Contact"
        title="Tell us what you're building."
        sub="From small repairs to full ADU builds, we're ready to help. Reach out and a specialist from our team will follow up within one business day."
        breadcrumbs={[{ label: "Home", to: "/" }, { label: "Contact" }]}
      />

      <section className="section-pad">
        <div className="container-page grid grid-cols-1 lg:grid-cols-12 gap-12">
          <aside className="lg:col-span-4 space-y-6">
            <div className="card-base p-7" data-testid="contact-info-card">
              <p className="overline mb-3">Reach us</p>
              <a href={BUSINESS.phoneHref} className="flex items-center gap-3 font-heading text-2xl font-bold text-brand-ink hover:text-brand-olive-hover" data-testid="contact-phone-cta">
                <Phone className="w-5 h-5 text-brand-olive" /> {BUSINESS.phone}
              </a>
              <p className="text-xs uppercase tracking-[0.18em] text-brand-ash mt-1 ml-8">{BUSINESS.phoneLabel}</p>
              <a href={BUSINESS.phoneAltHref} className="mt-4 flex items-center gap-3 font-heading text-xl font-bold text-brand-ink hover:text-brand-olive-hover" data-testid="contact-phone-alt-cta">
                <Phone className="w-5 h-5 text-brand-olive" /> {BUSINESS.phoneAlt}
              </a>
              <p className="text-xs uppercase tracking-[0.18em] text-brand-ash mt-1 ml-8">{BUSINESS.phoneAltLabel}</p>
              <a href={`mailto:${BUSINESS.email}`} className="mt-5 flex items-center gap-3 text-brand-ink hover:text-brand-olive-hover">
                <Mail className="w-4 h-4 text-brand-olive" /> {BUSINESS.email}
              </a>
              <a
                href={BUSINESS.instagram}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="contact-instagram"
                className="mt-3 flex items-center gap-3 text-brand-ink hover:text-brand-olive-hover"
              >
                <Instagram className="w-4 h-4 text-brand-olive" /> {BUSINESS.instagramHandle}
              </a>
              <div className="mt-4 flex items-start gap-3 text-sm text-brand-ash">
                <Clock className="w-4 h-4 text-brand-olive mt-0.5" />
                <span>{BUSINESS.hours}</span>
              </div>
              <div className="mt-4 flex items-start gap-3 text-sm text-brand-ash">
                <MapPin className="w-4 h-4 text-brand-olive mt-0.5" />
                <span>{BUSINESS.region}</span>
              </div>
            </div>

            <div className="card-base p-7">
              <p className="overline mb-3">Service Areas</p>
              <ul className="grid grid-cols-2 gap-y-1.5 text-sm">
                {SERVICE_AREAS.map((a) => (
                  <li key={a.slug} className="text-brand-ink">{a.name}</li>
                ))}
              </ul>
            </div>
          </aside>

          <div className="lg:col-span-8">
            <div className="card-base p-7 md:p-9">
              <p className="overline mb-3">Free estimate</p>
              <h2 className="heading-3 mb-6">Send us project details.</h2>
              <EstimateForm source="contact_page" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
